import { TooltipContainer } from './style';
import { TooltipProps } from './types';

export default function Tooltip({ title, left, bottom, width }: TooltipProps) {
  const custom = { left, bottom, width };
  return <TooltipContainer {...custom}>{title}</TooltipContainer>;
}
